import React from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

import styles from './style.module.scss'
import compareIcon from '@assets/images/icon/compare-icon.svg'
import swapIcon from '@assets/images/icon/swap-icon.svg'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import useModal from '@shared/hooks/useModal'
import { allRoutes } from '@shared/constants/allRoutes'
import { getImgURL } from '@shared/utils'

const MyImage = dynamic(() => import('@shared/components/myImage'))
const PlayerImg = dynamic(() => import('@shared/components/playerImg'))
const CommonModal = dynamic(() => import('@shared-components/commonModal'))
const PlayerCompareWidget = dynamic(() => import('@shared-components/player/playerCompare'))

const PlayerInfo = ({ playerDetails, isSmall, onChangePlayer }) => {
  const router = useRouter()
  const { t } = useTranslation()
  const { toggle, isShowing } = useModal()

  function handlePlayerSelect(p) {
    if (isSmall) {
      onChangePlayer && onChangePlayer(p)
    } else {
      const slug = (p?.oSeo?.sSlug || '').replace('cricket-players/', '')
      const p1Slug = (playerDetails?.oSeo?.sSlug || '').replace('cricket-players/', '')
      router.push(allRoutes.comparePlayer(p1Slug, slug))
    }
    toggle()
  }

  return (
    <>
      <div className={`${styles.playerInfo} ${isSmall ? styles.playerSmall : ''} common-box p-0 overflow-hidden position-relative`}>
        {isSmall &&
          <Button variant="link" onClick={toggle} className={`${styles.swap} position-absolute`} >
            <MyImage
              src={swapIcon}
              width="24"
              height="24"
              alt="swap"
            />
          </Button>
        }
        <div className={`${styles.info} ${isSmall ? 'p-2 p-sm-3 pb-0 pb-sm-0' : 'p-2 p-lg-3'} pb-0 mb-n3`}>
          <h3 className="mb-01 mb-md-0 text-nowrap text-uppercase t-ellipsis overflow-hidden me-4">{playerDetails?.sFullName || playerDetails?.sFirstName || '--'}</h3>
          <h3 className={`${styles.team} mb-1 small-head font-medium text-secondary d-flex align-items-center`}>
            <div className={`${styles.playerTeam} me-1 me-md-2 rounded-circle overflow-hidden`}>
              <MyImage
                src={getImgURL(playerDetails?.oPrimaryTeam?.oImg?.sUrl) || teamPlaceholder}
                width="24"
                height="24"
                alt="team"
              />
            </div>
            {playerDetails?.sCountryFull || playerDetails?.sNationality || '--'}
          </h3>
          {/* <div className={`${styles.ranking} mt-1 mt-md-2 xsmall-text font-semi text-muted position-absolute top-100`}>
            <p className="mb-0">#8 Batter in ODI</p>
            <p className="mb-0">#8 Batter in ODI</p>
            <p className="mb-0">#8 Batter in ODI</p>
          </div> */}
          {!isSmall &&
            <Button variant="link" onClick={toggle} className={`${styles.compare} theme-btn xsmall-btn d-flex align-items-center bottom-0 py-1 px-1 ms-lg-0 mt-2 mb-3 mb-md-n4 rounded-2`}>
              <span className={`${styles.icon} me-1`}>
                <MyImage
                  src={compareIcon}
                  width="24"
                  height="24"
                  alt="swap"
                />
              </span>
              <span>{t('common:ComparePlayer')}</span>
            </Button>
          }
        </div>
        <div className={`${styles.playerPic} ms-auto me-n1`}>
          <PlayerImg
            head={playerDetails?.oImg}
            jersey={playerDetails?.oPrimaryTeam?.oJersey}
            size={200}
          />
          {/* <MyImage
          src={getImgURL(playerDetails?.oImg?.sUrl) || playerPlaceholder}
          width="200"
          height="200"
          alt={playerDetails?.oImg?.sText || 'player'}
        /> */}
        </div>
      </div>
      {isShowing && (
        <CommonModal
          title={t('common:CompareBtn')}
          isConfirm={isShowing}
          cancel={{ event: toggle }}
        >
          <PlayerCompareWidget playerId={playerDetails?._id} handleSelect={handlePlayerSelect} />
        </CommonModal>
      )}
    </>
  )
}
PlayerInfo.propTypes = {
  playerDetails: PropTypes.object,
  onChangePlayer: PropTypes.func,
  isSmall: PropTypes.bool
}

export default PlayerInfo
